import Text from 'components/shared/Text'

import { FamilyConflictModalWrapper } from './styles'

import { FormattedMessage, useIntl } from 'react-intl'
import ModalInfo from 'components/shared/ModalInfo'
import { useAppSelector } from 'store/hooks'

interface FamilyConflictModalProps {
    onClick: () => void
    isLoading?: boolean
}

const FamilyConflictModal = ({
    onClick,
    isLoading,
}: FamilyConflictModalProps) => {
    const { formatMessage } = useIntl()
    const {
        familyPackage: { isConflictModalOpened },
    } = useAppSelector((state) => state.ticket)

    return (
        <ModalInfo
            isOpened={isConflictModalOpened}
            variant="primary"
            buttonLabel={formatMessage({
                id: 'global.btn.back_to_order',
                defaultMessage: 'Wróć do zamówienia',
            })}
            onButtonClick={() => onClick()}
            width={490}
            isLoading={isLoading}
            testIdPrefix="package-conflict-modal"
        >
            <FamilyConflictModalWrapper gap={16}>
                <Text variant="heading3" color="grayscale_900">
                    <FormattedMessage
                        id="package.family.conflict_modal_title"
                        defaultMessage="Nie udało się dodać produktu do koszyka"
                    />
                </Text>
                <Text variant="body" color="grayscale_900">
                    <FormattedMessage
                        id="package.family.conflict_modal_body_text"
                        defaultMessage="Nie możesz zakupić zakwaterowania i Pakiety Family w tej samej transakcji. Prosimy o zakup zakwaterowania oddzielnie."
                    />
                </Text>
            </FamilyConflictModalWrapper>
        </ModalInfo>
    )
}

export default FamilyConflictModal
